<script setup lang="ts">
import { Image } from '@/components';
import { useOfficialStyle } from './use-official-style.ts';
import { useRouter } from 'vue-router';
import type { FilterResult } from '@/api/cloud-resource';
import { showToast } from 'vant';
import { InfiniteScrollList } from '../infinite-scroll-list';

const { loading, results, noMore, top, loadNextPage, loadPrevPage } = useOfficialStyle();

const router = useRouter();
const onClick = async (item: FilterResult & { anchor: string }) => {
  const sco = item.sco[0];
  if (!sco) {
    showToast('未找到资源');
    return;
  }

  localStorage.setItem('lastOfficialStyleHash', item.anchor);

  let query = {};
  const regex = /^(?:https?:\/\/)?(?:[\w-]+\.)?cloudknit\.cn(?:\/project)?\/(\w+)$/;
  const match = sco.match(regex);
  if (match && match[1]) {
    query = {
      sco: undefined,
      scoId: match[1],
      originScoUrl: btoa(sco)
    };
  } else {
    query = {
      sco: btoa(sco),
      scoId: item.id
    };
  }

  const lastRoute = JSON.parse(localStorage.getItem('lastRoute') || '{}');
  await router.replace({
    name: 'fabric',
    params: {
      id: 'default',
      ...lastRoute.params
    },
    query: {
      ...lastRoute.query,
      ...query
    }
  });
};

async function loadMore() {
  await loadNextPage();
  loading.value = false;
}

async function loadPrev() {
  await loadPrevPage();
  loading.value = false;
}
</script>

<template>
  <div :class="$style.listContainer">
    <InfiniteScrollList
      v-model:loading="loading"
      :finished="noMore"
      :top="top"
      finished-text="没有更多了"
      @load="loadMore"
      @load-prev="loadPrev"
    >
      <div :class="$style.cardList">
        <div
          :class="$style.card"
          v-for="item of results"
          :key="item.id"
          @click="()=>onClick(item)"
          :id="`style-${item.anchor}`"
        >
          <Image
            :src="item.image[0]||''"
            lazy-load
            :height="200"
            fit="scale-down"
          />
          <div :class="$style.name">
            {{ item.name }}
          </div>
        </div>
      </div>
    </InfiniteScrollList>
  </div>

</template>

<style module>
.listContainer {
  height: 100%;
  overflow-y: auto;
}

.listContainer {
  height: 100%;
  overflow-y: auto;
}

.cardList {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: minmax(230px, auto) 1fr;
}

.cardList:empty {
  height: 0;
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px;
  min-height: 220px;
}

.name {
  padding: 0 10px;
}
</style>

